/**************************************************
 * Nombre:       Seccion_Inicio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_MONEDA,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext, useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {ESTADOMOVIMIENTOS} from "../../Constantes";
import Tarjeta_Boton_Nuevo_Ahorro from "../Tarjeta/Tarjeta_Boton_Nuevo_Ahorro";
import {usuarioContext} from "../../App";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import Bolsillo from "./Componentes/Bolsillo";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {irUrl} from "../../Utilidades/irUrl";
import Dialogo_Ver_Deposito from "../Dialogos/Dialogo_Ver_Deposito";
import Dialogo_Ahorro from "../Dialogos/Dialogo_Ahorro";


const Seccion_Inicio = () => {
    const cData = useContext(usuarioContext)
    const [wheres, setWheres] = useState([where('idUsuario', '==', 'none')])
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'movimientos', wheres: wheres})
    const {Dialogo, abrir, cerrar} = useDialogo({
        Componente: Dialogo_Ver_Deposito,
        titulo: 'Detalles Deposito',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoNuevo, abrir: abrirNuevo, cerrar: cerrarNuevo} = useDialogo({
        Componente: Dialogo_Ahorro,
        titulo: 'Detalles Deposito',
        realizado: cargarNuevamente
    })
    const [bolsillos, setBolsillos] = useState([])
    const [cargar, setCargar] = useState(false)

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'recibo':
                irUrl('https://obtenerpromo.com/recursos/recibo.pdf')
            default :
                abrir(data)
        }
    }

    const recargar = () => {
        setCargar(!cargar)
    }


    const abrirNuevAhorro = () => {

        const funcion = () => {
            cargarNuevamente()
            setCargar(!cargar)
            cerrar()
        }

        abrirNuevo({realizado: funcion})
    }

    useEffect(() => {

        if (cData.usuario && cData.usuario.id) {

            let w = [where('idUsuario', '==', cData.usuario.id)]

            obtenerColWheres({col: 'bolsillos', wheres: w}).then((dox) => {
                if (dox.res && dox.data) {
                    setBolsillos(dox.data)
                }
                setWheres(w)
            })
        }


    }, [cData, cargar]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoNuevo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {bolsillos.map((item, index) => (
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Bolsillo item={item} recargar={recargar}/>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 4}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Boton_Nuevo_Ahorro click={abrirNuevAhorro}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Movimientos'}
                        descripcion={`${numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        //  clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Inicio

const filtros = [
    {
        nombre: 'Tipo',
        direccion: 'asc',
        propiedad: 'tipo'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Fecha y Num',
        direccion: 'left',
        propiedades: ['consecutivo', 'nombreBolsillo'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Tipo',
        direccion: 'left',
        propiedad: 'tipo',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Cuota del Mes',
        direccion: 'left',
        propiedad: 'mes',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        tipo: CASILLA_MONEDA

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOMOVIMIENTOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]